<template>
	<div class="Guide">
		<div class="row px-3">		
			<card class="post mt-2 focus-shadow">
				<div class="py-3">
					<h5><i class="tim-icons icon-send text-success mr-3"></i>Добавить данные в таблицу</h5>
				</div>
				<div class="postAddForm">		
					<form class="form-container">
						<div class="top_part">  
							<div class="col-sm-6 col-md-4 pl-0">
								<base-input
								placeholder="Название"
								v-model="objAddRestr.restrName"
								autocomplete="off"
								></base-input>
							</div>
							<div class="col-sm-6 col-md-4  pl-0">
								<base-input
								placeholder="Описание"
								v-model="objAddRestr.restrDescr"
								autocomplete="off"
								></base-input>
							</div>
							<div class="col-sm-6 col-md-4">
								<span class="mr-3">Активен</span>
								<base-switch										
									v-model="objAddRestr.restrAct"
									type="primary"
									on-text="Да"
									off-text="Нет"
								></base-switch>
								
							</div>
						</div>

						<div class="bottom_part mt-2">
							<base-button type="success" simple @click="AddNewRestriction()"><i class="tim-icons icon-send mr-2"></i>Отправить</base-button>										
						</div>
					</form>						
				</div>
			</card>
		
		</div>

		<tabs type="primary"
            tabContentClasses="tab-opt"
            centered
            inline
            round
			:activeTab="currentTab"
			@change="OnTabChange"	
            class="card card-plain" 
		>
			<tab-pane :id="cat_name" :key="cat_name"  v-for="(cat,cat_name) in objCats">
				<span slot="label" class="tab-label">
					<i class="tab-icon tim-icons icon-paper"></i>
					<span>{{cat.descr}}</span>
				</span>				
				<div>	<!--v-if="cat_name == 'CAT_AD_RESTRICTIONS'"-->
					<h3 class="d-md-flex d-lg-none justify-content-center text-center mb-3">{{cat.descr}}</h3>
					<div class="row px-3">
						<ReRestrictions :masRestrictionList="masRestrictionList" :masActions="masActions"/>
					</div>					
				</div>
				
			</tab-pane>
        </tabs>

	</div>
</template>

<script>
	import ReRestrictions from 'src/our_components/ReRestrictions.vue';
	import { TabPane, Tabs, BaseSwitch } from 'src/components';
	import { Table, TableColumn } from 'element-ui';
	


	export default {
		name: 'guide-page',
		components: {
			TabPane, 
			Tabs,
			[Table.name]: Table,
			[TableColumn.name]: TableColumn,
			BaseSwitch,
			ReRestrictions,			
		},
		props: {
			
		}, 
		
		data() {
			return {
				objCats:{},
				cat: {},	
				masActions:[],				
				masRestrictionList: [],
				objAddRestr: {},				
				switches: {
					defaultOn: true,
					defaultOff: false,
				},
				strCurTab:'',
				currentTab: 'CAT_AD_RESTRICTIONS',
				bCatsStarted: false,
				objCats0:{}
    		}
		},
		methods: {
			
		GetCat(){
			this.$GVO.ApiCall('GET_ALL_CAT_LIST',{obj:'cat', flt:{virt:false}})
			.then((objApi) => {		
				// console.log(objApi);		
				if(objApi.success === true){
					this.objCats = objApi.data;
					let i = 0;
					for (const key in objApi.data) {
						
						if (objApi.data.hasOwnProperty(key)) {
							if(i==0) this.strCurTab = key;
							i++;
						}
					}
					this.GetRestr();
				}
			}).catch(errorObjApi => {console.error(errorObjApi);});
		},			
		
		OnTabChange(strTabId){
			this.strCurTab = strTabId;
			this.GetRestr();
			//this.$emit('input', strTabId);
			//this.$emit('change', strTabId);
		},
		GetRestr(){	
			let strACT_METHOD = '';
			this.$GVO.ApiCall('GET',{obj:'cat', flt: {cat_name: this.strCurTab}})
			.then((objApi) => {				
				if(objApi.success === true){
					if(objApi.data.length > 0){
						if(this.strCurTab=='CAT_AD_RESTRICTIONS'){
							strACT_METHOD = 'CHANGE_ACT_RESTRICTIONS';
						}else if(this.strCurTab=='CAT_AGREGATORS'){
							strACT_METHOD = 'CHANGE_ACT_AGREGATORS';
						}else if(this.strCurTab=='CAT_GK_FOLDERS'){
							strACT_METHOD = 'CHANGE_ACT_GK_FOLDERS';
						}else if(this.strCurTab=='CAT_TICKET_TAGS'){
							strACT_METHOD = 'CHANGE_ACT_TICKET_TAGS';
						}else if(this.strCurTab=='CAT_FORMFIELD_NAMES'){
							strACT_METHOD = 'CHANGE_ACT_FORMFIELD_NAMES';
						}else if(this.strCurTab=='CAT_VACANCY'){
							strACT_METHOD = 'CHANGE_ACT_VACANCY';
						}else if(this.strCurTab=='cat_coldcall_type'){
							strACT_METHOD = 'CHANGE_ACT_coldcall_type';
						}else{
							strACT_METHOD = 'CHANGE_ACT_UNIVERSAL';
						}

						// else if(this.strCurTab=='cat_coldcall_type'){
						// 	strACT_METHOD = 'CHANGE_ACT_coldcall_type';
						// }
						
						
						this.masRestrictionList = objApi.data;
							
						this.masActions = [];
						for (let i = 0; i < this.masRestrictionList.length; i++) {
							if(this.masRestrictionList[i].read_only==1)
								this.masActions.push([]);
							else
								this.masActions.push([
									{
										actionType: 'switcher',
										label_on: 'Вкл',
										label_off: 'Выкл',
										action_model: this.masRestrictionList[i].act=='1'?true:false,						
										onClickApi: {apiMethod:strACT_METHOD,apiParam:{obj:'cat',flt:{cat_name: this.strCurTab, id:this.masRestrictionList[i].id}}},
									},
									{
										actionType: 'btn_del',
										onClickApi: {apiMethod:'DEL',apiParam:{obj:'cat',flt:{cat_name: this.strCurTab, id:this.masRestrictionList[i].id }}},
									},
								]);
						}
										
					} else {
						this.masRestrictionList = [];
					}
				} 
			}).catch(errorObjApi => console.error(errorObjApi));
		},
		AddNewRestriction() {
			this.$GVO.ApiCall('INS', {obj:'cat', flt: {cat_name: this.strCurTab}, iData:{
					id: this.objAddRestr.id,
					val: this.objAddRestr.restrName,
					act: this.objAddRestr.restrAct,
					descr: this.objAddRestr.restrDescr,							
					}
				}
			)
			.then((objApi) => {
				//console.log(objApi);
				if(objApi.success === true){
					if(objApi.data.length > 0) {
						this.masRestrictionList = objApi.data;												
					}
					this.GetCat();
					this.objAddRestr.restrName = '';
					this.objAddRestr.restrDescr = '';					
				} else {this.$GVO.showAlert('Редактирование справочника',objApi.msg);}	
										
			}).catch(errorObjApi => console.error(errorObjApi));
		},


		},
		mounted() {
			this.GetCat();
			
		}
	};
</script>

<style scoped>

/*============================ SEND NOTES ========================================*/

.Guide .post {
	border: 1px solid transparent;
	border: 1px solid #01B0E0;
	border-radius: 0.2857rem;
	position: sticky;
	bottom: 0;		
}
.Guide .post >>> .card-body {padding: 0px 5px 15px 10px!important;}
.Guide .cancel-note-btn {position: absolute;  top: 0; right: 0;}
.Guide .clientPage .card-collapse .post {
	background: #27293d;
}
.Guide .white-content .card:not(.card-white) .post {
	background: #fff;
}
.Guide .postForm:hover, .focus-shadow  {
	box-shadow: 0px 0px 10px rgba(1, 176, 224, 0.3);
}
.Guide .post h5 {
	margin-bottom: 0px;
}
.Guide .form-container {display: flex; flex-direction: column; justify-content: space-between; padding: 0px 5px;}
.Guide .post .bottom_part, .top_part  {display: flex; flex-wrap: wrap; justify-content: space-between;}
.Guide .post .bottom_part button, .fileinput {margin: 10px 10px 0px 0px;}

.Guide .postAddForm >>> .nav-pills .nav-item i {line-height: 30px;}
.Guide .postAddForm >>> .nav-pills .nav-item .nav-link {padding: 7px 20px; min-width: 80px;}
.Guide .postAddForm >>> .tab-space {padding: 20px 0 10px 0px;}
.Guide .upload-file {display: flex; align-items: center;}
.Guide .upload-file h5 {margin-bottom: 0px; margin-right: 10px;}

.Guide .note-btn-group {position: relative;}
.Guide .note-btn-row {position: absolute; top: 5px; right: 0;}

.Guide >>> .nav-pills .nav-item .nav-link { padding: 1px 23px;}
.Guide >>> .bootstrap-switch {margin-bottom: 0px;}


.Guide >>> .card-title {margin-bottom: 0px;}
.display-none {display: none;}
.Guide .tab-mobile {display: none;}

/*===media===============================*/
@media (max-width: 919px) {	
	.Guide .tab-mobile {
		display: inline-block;
	}
	.Guide >>> .tab-label > span {
        display: block;
    }
}

</style>
